import React from 'react'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'

const MedicineName = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12}>
    <TextField
      label="Medicine Name"
      fullWidth
      value={moduleValues?.['Medicine Name'] ?? ''}
      onChange={(e) =>
        setModuleValues((prev) => ({
          ...prev,
          ['Medicine Name']: e.target.value,
        }))
      }
    />
  </Grid>
)

export default MedicineName
